export const SUBMIT_TYPES = {
  DRAFT: 'DRAFT',
  SCHEDULE: 'SCHEDULE',
  PUBLISH: 'PUBLISH',
  DELETE: 'DELETE',
  ARCHIVE: 'ARCHIVE',
  REMOVE_SCHEDULED: 'REMOVE_SCHEDULED',
  SAVE: 'SAVE',
  DELETE_ARCHIVED: 'DELETE_ARCHIVED',
};

export const LINK_STATUS = {
  DRAFT: 'draft',
  SCHEDULED: 'scheduled',
  PUBLISHED: 'published',
  ARCHIVED: 'archived',
  DELETED: 'deleted',
};
